import {  useEffect, useRef, useState } from "react";

interface UseAsyncReturn<T> {
  data: T | undefined;
  error: Error | undefined;
  loading: boolean;
  execute: UseAsyncFunction;
}

type UseAsyncFunction<T=unknown> = (...args:any[]) => Promise<T>;

interface AsyncOpts {
  /**
   * @deprecated. Use `immediate` instead.
   */
  inmediate?: boolean;
  
  immediate?: boolean; 
}

function useAsync<T>(asyncFn: UseAsyncFunction<T>, {inmediate, immediate}: AsyncOpts = {inmediate: false}): UseAsyncReturn<T> {
  const [data, setData] = useState<U | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(!!inmediate);
  const mountRef = useRef(true);


  useEffect(() => {
    return () => {
      mountRef.current = false;
    };
  }, []);


  const execute = async (...args: T[]) => {
    const isMounted = mountRef.current;
    if (!isMounted) return;

    setLoading(true);
    setError(null);
    setData(null);
    return asyncFn?.(...args)
      .then((res) => setData(res))
      .catch((err) => {setError(err); throw err;})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (inmediate || immediate) {
      execute();
    }
  }, [inmediate, immediate]);

  return { data, error, loading, execute };
}

export default useAsync;